import { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";

// SVGs
import PlusSvg from "../../assets/assets_svg/addicon.svg";
import deleteSvg from "../../assets/assets_svg/delete.svg";

import { DeleteConformation } from "../DeleteConformation";
import { getApi, patchApi, postApi } from "../../Helpers/Axios";
import { DateConverter } from "../../Helpers/Helper";
import { Pagination } from "../Pagination";
import { useSelector } from "react-redux";

import toast from "react-hot-toast";
import moment from "moment";

const PendingDemise = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const admin = useSelector((state) => state?.auth?.user);
  const [pendingDemiseData, setPendingDemiseData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [delId, setDelId] = useState(0);

  // Pagination assets
  const [dataCount, setDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [searchData, setSearchData] = useState("");

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    setIsLoadingData(true);
    fetchPendingDemise();
  }, [currentPage, searchData]);

  useEffect(() => {
    if (!modalShow) {
      fetchPendingDemise();
    }
  }, [modalShow]);

  const fetchPendingDemise = async () => {
    let url =
      searchData !== ""
        ? `pending-demise?page=${currentPage}&search=${searchData}`
        : `pending-demise?page=${currentPage}`;
    await getApi(url, true).then((response) => {
      if (response.status === 200) {
        console.log("🚀 ~ awaitgetApi ~ response.data:", response.data);
        setPendingDemiseData(response.data);
        setDataCount(response.dataCount);
        setTotalPage(response.totalPage);
        setIsLoadingData(false);
      } else {
        setIsLoadingData(false);
      }
    });
  };

  const handleApproveStatus = async (id) => {
    console.log("🚀 ~ handleApproveStatus ~ id:", id);
    let url = `sad-demise/${id}`;
    let bodyData = {};
    await patchApi(url, bodyData, true)
      .then(async (response) => {
        if (response.status === 200) {
          toast.success("Event Approved", {
            duration: 3000,
            position: "top-center",
          });
          fetchPendingDemise();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (pageNum) => {
    // Ensure the page number is within range
    if (pageNum < 1 || pageNum > totalPage) return;
    setCurrentPage(pageNum);
    // Perform any additional data fetching or state update logic here
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <p className="m-0 breadcrumbs">
          <span>
            <Link to={"/dashboard"}>Dashboard</Link> /
          </span>{" "}
          Pending Demise
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <input
            type="search"
            placeholder="Searching...."
            class="search-input me-3"
            name="title"
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
          />
        </div>
      </div>

      <div className="data-table mt-3">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th>Expire At</th>
              <th>Upload By</th>
              <th>Member Village</th>
              <th className="text-center" style={{ width: "140px" }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {!isLoadingData ? (
              pendingDemiseData?.length ? (
                pendingDemiseData?.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val?.id}</td>
                      <td>
                        <img
                          alt="profile_img"
                          src={`${process.env.REACT_APP_IMAGE_URL}${val?.image}`}
                          style={{ height: 60, width: 60, borderRadius: 30 }}
                          onClick={() => setPreviewImage(`${process.env.REACT_APP_IMAGE_URL}${val?.image}`)}
                        />
                      </td>
                      <td>{`${val?.title}`}</td>
                      <td>{`${val?.description}`}</td>
                      <td> {val?.expiry_date ? moment(val?.expiry_date, "YYYY-MM-DD").format("DD-MM-YYYY") : ""}</td>
                      <td>{`${val?.memberData?.name_gj} ${val?.memberData?.surnameData?.name_gj}`}</td>
                      <td>{`${val?.memberData?.villageData?.name_gj}`}</td>

                      {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
                        <td>
                          <div className="data-action">
                            <span
                              className="btn btn-small btn-danger action-icon"
                              onClick={() => {
                                setModalShow(true);
                                setDelId(val.id);
                              }}
                            >
                              <img src={deleteSvg} alt="" />
                            </span>
                          </div>
                        </td>
                      ) : (
                        ""
                      )}

                      <td className="text-center">
                        <button className="btn btn-success" onClick={() => handleApproveStatus(val?.id)}>
                          Approve
                        </button>
                      </td>
                    </tr>
                  );
                  // }
                })
              ) : (
                <tr className="text-center">
                  <td colSpan={12}>Not found</td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={12} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Image Viewer Overlay */}
      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={previewImage}
            alt="Preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}

      {/* Render Pagination component */}
      <Pagination dataCount={dataCount} currentPage={currentPage} totalPage={totalPage} page={handlePageChange} />

      <DeleteConformation show={modalShow} onHide={() => setModalShow(false)} title="task" url={`news/${delId}`} />
    </>
  );
};

export default PendingDemise;
